'use client';
import * as Dialog from '@radix-ui/react-dialog';
import { Path } from '@trwl/shared/lib/router';
import { createStateful } from '@trwl/shared/lib/stateful';
import { Sidebar } from '@trwl/shared/ui/sidebar';
import { $brands } from '@trwl/store';
import { serializeFilterToQuery } from '@trwl/store/filter/serializer';
import { NavigationSidebar } from '@trwl/widgets/nav/sidebar';
import { useUnit } from 'effector-react';
import { AnimatePresence } from 'framer-motion';
import { useRouter } from 'next/navigation';
import { CgClose } from 'react-icons/cg';

export const BrandsSidebar = createStateful(({ state, setState }) => {
  const active = useUnit(state);
  const brands = useUnit($brands);
  const router = useRouter();

  return (
    <Dialog.Root
      open={active.active}
      onOpenChange={(open) =>
        setState({
          active: open,
        })
      }
    >
      <AnimatePresence>
        {active.active && (
          <Dialog.Portal forceMount>
            <Sidebar.Content
              asChild
              forceMount
              className="border-none outline-none md:w-[600px] py-[92px] px-[64px] z-[2000] w-[100%] justify-between md:rounded-tr-[12px] md:rounded-br-[12px] md:border-r-[2px] md:border-r-[#F6F6F6]"
            >
              <CgClose
                className="absolute cursor-pointer w-7 h-7 fill-[#B6B6B6]"
                onClick={() =>
                  setState({
                    active: false,
                  })
                }
                style={{
                  top: 25,
                  right: 25,
                }}
              />
              <div className="flex flex-col gap-[15px] overflow-scroll overflow-x-hidden">
                {brands
                  .filter((brand) => brand.priority > 0)
                  .map((brand) => (
                    <div
                      key={brand.id}
                      onClick={() => {
                        NavigationSidebar.store.stateChanged({
                          active: false,
                        });
                        setState({
                          active: false,
                        });
                        router.push(
                          `${Path.CATALOG}?filter=${serializeFilterToQuery({
                            brandIds: [brand.id],
                          })}`,
                        );
                      }}
                      className="relative text-primary w-auto text-[20px] whitespace-nowrap"
                    >
                      {brand.name}
                    </div>
                  ))}
              </div>
            </Sidebar.Content>
          </Dialog.Portal>
        )}
      </AnimatePresence>
    </Dialog.Root>
  );
});
